<app-nav *ngIf="routeType === 'user' && showNav "></app-nav>
<app-nav-lite *ngIf="showNavLite"></app-nav-lite>
<app-admin-nav *ngIf="routeType === 'admin' && showNav "></app-admin-nav>
<main>
  <router-outlet></router-outlet>
</main>